export const RECEIVE_CHECK_OUT_PASSENGER = 'RECEIVE_CHECK_OUT_PASSENGER'

export default (passengerId: string, flightId: string) => ({
  type: RECEIVE_CHECK_OUT_PASSENGER,
  passengerId,
  flightId,
})
